import type { LiveConsultService } from "@/App/components/liveConsult/types/LiveConsultService";

import config from "@/App/config/main";
import { HttpClient } from "@/App/services/httpClient/HttpClient";

export const liveConsultService: LiveConsultService = {
  getLiveConsultToken: ({ caseId, identity }) => {
    return HttpClient.get({
      path: `${config.API_URL}/notification/twiage-cases/${caseId}/room`,
      params: identity ? { identity } : undefined,
    });
  },
};
